import { useState } from "react";
import { Button } from "@/components/ui/button";
import { X, ClipboardCheck } from "lucide-react";
import { cn } from "@/lib/utils";
import { StudentReport, GroupReport } from "@/components/attendance/AttendanceReports";
import RecoveriesPanel from "@/components/attendance/RecoveriesPanel";

const TABS = [
  { id: "student", label: "Per allievo" },
  { id: "group", label: "Per gruppo" },
  { id: "recoveries", label: "Da recuperare" },
];

export default function AdminAttendance({ token, registrations, groups, readOnly, onClose }) {
  const [tab, setTab] = useState("student");
  return (
    <div className="fixed inset-0 z-50 bg-slate-50 flex flex-col" data-testid="admin-attendance">
      <div className="bg-white border-b border-slate-200">
        <div className="max-w-7xl mx-auto px-4 py-3 flex items-center justify-between gap-3">
          <div className="flex items-center gap-2 font-bold text-slate-900 text-lg">
            <ClipboardCheck className="w-5 h-5 text-[#15803D]" /> Presenze
          </div>
          <Button variant="outline" onClick={onClose} className="gap-1.5" data-testid="admin-attendance-close-btn">
            <X className="w-4 h-4" /> Chiudi
          </Button>
        </div>
        <div className="max-w-7xl mx-auto px-4 flex gap-1 overflow-x-auto">
          {TABS.map((t) => (
            <button key={t.id} onClick={() => setTab(t.id)} data-testid={`attendance-tab-${t.id}`}
              className={cn("px-4 py-2.5 text-sm font-semibold border-b-2 whitespace-nowrap",
                tab === t.id ? "border-[#15803D] text-[#15803D]" : "border-transparent text-slate-500")}>
              {t.label}
            </button>
          ))}
        </div>
      </div>
      <div className="flex-1 overflow-y-auto">
        <div className="max-w-7xl mx-auto px-4 py-6">
          {tab === "student" && <StudentReport token={token} registrations={registrations} />}
          {tab === "group" && <GroupReport token={token} groups={groups} />}
          {tab === "recoveries" && <RecoveriesPanel token={token} readOnly={readOnly} />}
        </div>
      </div>
    </div>
  );
}
